import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Old order URLs open /book with the right choice made, keeping any query (e.g. ?package=, ?checkout=).
export const LegacyBookRedirect = ({ type }) => {
  const params = new URLSearchParams(useLocation().search);
  params.set('type', type);
  return <Navigate to={`/book?${params.toString()}`} replace />;
};
